/**
 * en-GB messages added by Phase 2 task W15 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w15EnGB = {
    // Member drawer tabs (the "CloudSign app" tab shows when the Companion module is on and the user manages members)
    'membersUi.drawer.tab.details': 'Details',
    'membersUi.drawer.tab.app': 'CloudSign app',
    // OMP link: lines of the latest-messages table (outbound lines reuse whk.event.* and whk.delivery.*)
    'peo.omp.msgType.sign_in': 'Sign-in from OMP',
    'peo.omp.msgType.sign_out': 'Sign-out from OMP',
    'peo.omp.msgStatus.applied': 'Done',
    'peo.omp.msgStatus.merged': 'Joined to an existing visit',
    'peo.omp.msgStatus.pending': 'Waiting',
    'peo.omp.msgStatus.unmatched': 'Needs matching',
    'peo.omp.msgStatus.rejected': 'Refused',
    'peo.omp.msgStatus.duplicate': 'Already received',
};
//# sourceMappingURL=w15.js.map